<div class="input-group" id="input-group-{{id}}">
    <input class="form-control w-100 customize" id="input-{{id}}" placeholder="{{placeholder}}"
        (keydown)="catchKeydown($event)" [(ngModel)]="amountText" [disabled]="disabled" (ngModelChange)="changeValue()"
        [ngClass]="isError ? 'border-red' : ''" />
    <span class="input-unit" *ngIf="unit">{{unit}}</span>
</div>